import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";
import { LicencePlateField } from "../../../../general/fields/modules/commons/licencePlateField/licencePlateField";
import { CrudCustomPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudCustomInput";

export const RequestTiresetFormTemplate = () => {
  return (
    <Row>
      <Col md="12">
        <CrudPlaceholderInput name="relation_id" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="type" />
      </Col>
      <Col md="4">
        <CrudCustomPlaceholderInput
          name="licence_plate"
          component={LicencePlateField}
        />
      </Col>
      <Col md="8">
        <CrudPlaceholderInput name="tire_type" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="updated_at" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="invoice_status" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="in_out_storage" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="pickup_and_delivery_date" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="work_order_number" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="tiresFreestock" />
      </Col>
    </Row>
  );
};
